import styled from 'styled-components';
import { Link } from 'react-router-dom';

export const LinkStyled = styled(Link)`
  align-items: center;
  display: inline-flex;
  gap: 4px;
  line-height: 1;
  text-decoration: ${props => props.$noUnderline ? 'none' : 'underline'};

  &:hover {
    text-decoration: ${props => props.$noUnderline ? 'none' : 'underline'};
  }

  .anticon {
    &,
    svg {
      vertical-align: middle;
    }
  }
`;
